










































import DownloadDia from '@/components/DownLoadDia.vue'; // 下载弹框组件
import Vue from 'vue';
import * as api from '@/api';
import CardProduct from '@/components/CardProduct.vue';
import FilterTags from '@/components/FilterTags.vue';
import CardContainer from '@/components/CardContainer.vue';
import ProductFilter from '@/components/ProductFilter.vue';
import PanelFold from '@/components/PanelFold.vue';
import { getFileTypes } from '@/api/File';

interface ProductFilterData {
    brands: api.FilterBrand[];
    categories: api.FilterCategory[];
    fileTypes: api.FilterFileType[];
    advanced: {
        keyword: string;
        rangeInput?: {
            minValue: number;
            maxValue: number;
            isAsc: boolean;
        };
        listSelectValue?: string;
    }[];
}

export default Vue.extend({
    name: 'ProductList',
    props: {
        keyword: {
            type: String,
            default: '',
        },
    },
    components: {
        DownloadDia,
        CardProduct,
        FilterTags,
        CardContainer,
        ProductFilter,
        PanelFold,
    },
    data() {
        return {
            brandCount: 0,
            productCount: 0,
            productCards: [] as api.ProductCard[],
            filter: {
                brands: [],
                categories: [],
                fileTypes: [],
                advanced: [],
            } as ProductFilterData,
            sortFields: [
                {
                    label: '收藏数量',
                    id: 'collectedCount DESC, id DESC',
                },
                {
                    label: '更新时间',
                    id: 'releasedTime DESC',
                },
            ],
            sortField: 'collectedCount DESC, id DESC',
            fileTypes: [],
            dialogVisible: {
                show: false,
            },
            dataLoading: true,
        };
    },
    computed: {
        filterCount(): number {
            return this.filter.brands.length + this.filter.categories.length + this.filter.fileTypes.length;
        },
        user(): api.User {
            return this.$store.state.user;
        },
    },
    watch: {
        keyword() {
            this.fetchData();
        },
        filter() {
            this.fetchData();
        },
        sortField() {
            this.fetchData();
        },
    },
    async created() {
        if (this.user) { // 用户未登录不拉取这个接口，以免造成不登陆时不能正常访问产品列表页面
            this.$store.dispatch('getProductCompareList');
        }
        await this.fetchData();
    },
    methods: {
        async fetchData() {
            const cntRes = await api.getProductListCount({
                keyword: this.keyword,
                brandIds: this.filter.brands.map((b) => b.id),
                categoryIds: this.filter.categories.map((c) => c.id),
                fileTypeNames: this.filter.fileTypes.map((f) => f.name),
                // todo: 高级筛选
                highFilterProperties: this.filter.advanced,
            });
            if (!api.error(cntRes)) {
                this.brandCount = cntRes.data.brandCount;
                this.productCount = cntRes.data.productCount;
            }
            this.dataLoading = true;
            const res = await api.getProductList({
                keyword: this.keyword,
                brandIds: this.filter.brands.map((b) => b.id),
                maxResultCount: 40,
                categoryIds: this.filter.categories.map((c) => c.id),
                fileTypeNames: this.filter.fileTypes.map((f) => f.name),
                sorting: this.sortField,
                highFilterProperties: this.filter.advanced,
            });
            if (!api.error(res)) {
                this.productCards = res.data.items;
            }
            this.dataLoading = false;
        },
        async downloadFile(item) {
            const fileTypes = await getFileTypes({ id: item.id, pvId: item.pvId });
            if (!api.error(fileTypes)) {
                fileTypes.data.length === 0 && this.$message({ type: 'info', message: '暂无模型文件可供下载' });
                fileTypes.data.length > 0 && (this.fileTypes = fileTypes.data) && (this.dialogVisible.show = true);
            }
        },
        async loadMore() {
            if (this.productCards.length === this.productCount) return;
            this.dataLoading = true;
            const res = await api.getProductList({
                keyword: this.keyword,
                brandIds: this.filter.brands.map((b) => b.id),
                maxResultCount: 40,
                categoryIds: this.filter.categories.map((c) => c.id),
                fileTypeNames: this.filter.fileTypes.map((f) => f.name),
                sorting: this.sortField,
                skipCount: this.productCards.length,
            });
            if (!api.error(res)) {
                this.productCards = [...this.productCards, ...res.data.items];
            }
            this.dataLoading = false;
        },
    },
});
